import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../componets/headerwebsite/headerweb";
import FooterWeb from "../componets/footerwebsite/footerweb";
import { Avatar, Button, Card, Carousel, Form, Input, Modal, notification, Rate } from "antd";
import './viewproductDetail.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faComments } from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";

import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Heart, MessageCircle, Share2 } from "lucide-react";


interface Product {
    id: number;
    productTitle: string;
    Price: number;
    descriptionProduct: string;
    brand: string;
    color: string;
    gender: string;
    size: string;
    shipping: string;
    stock_product?: string; // Add stock_product field
    productImage1?: string;
    productImage2?: string;
    productImage3?: string;
}

// Initialize dayjs plugins for timezone handling
dayjs.extend(utc);
dayjs.extend(timezone);
interface EngagementData {
    EngagementLike: number;
    EngagementComments: string[];
    EngagementShare: number;
}
const ViewProductDetails: React.FC = () => {
    const { id } = useParams();
    const [data, setData] = useState<any>([]);
    const [reviewData, setReviewData] = useState<any>([]);
    const [ProductfilterData, setProductfilterData] = useState<any>([]);
    const [productImages, setProductImages] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [visibleCount, setVisibleCount] = useState(3);
    const showMoreReviews = () => setVisibleCount(reviewData.length);
    const showLessReviews = () => setVisibleCount(3);
    const [form] = Form.useForm();
    const [showScroll, setShowScroll] = useState(false);
    const [offerdata, setofferdata] = useState<any>([]);

    const [engagements, setEngagements] = useState<{ [productId: number]: EngagementData }>({});
    const [activeProduct, setActiveProduct] = useState<Product | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newComment, setNewComment] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
    }, [engagements]);

    const fetchEngagementData = async (productId: number) => {
        try {
            const response: any = await GET(`${API.FIND_ONE_ENGAGEMENT_BUTTON}${productId}`, {});
            const data = response?.data || []; // ✅ Fix here


            if (!Array.isArray(data) || data.length === 0) {
                setEngagements((prev) => ({
                    ...prev,
                    [productId]: {
                        EngagementLike: 0,
                        EngagementShare: 0,
                        EngagementComments: [],
                    },
                }));
                return;
            }

            let totalLikes = 0;
            let totalShares = 0;
            const allComments: string[] = [];

            data.forEach((item: any) => {
                const likes = Number(item.EngagementLike) || 0;
                const shares = Number(item.EngagementShare) || 0;
                totalLikes += likes;
                totalShares += shares;

                if (item.EngagementComments && item.EngagementComments.trim()) {
                    try {
                        const parsed = JSON.parse(item.EngagementComments);
                        if (Array.isArray(parsed)) {
                            allComments.push(...parsed.filter((c: string) => c && c.trim() && c !== "string"));
                        } else if (typeof parsed === "string" && parsed.trim() && parsed !== "string") {
                            allComments.push(parsed);
                        }
                    } catch {
                        if (item.EngagementComments !== "string" && item.EngagementComments.trim()) {
                            allComments.push(item.EngagementComments);
                        }
                    }
                }
            });

            const uniqueComments = Array.from(new Set(allComments));

            setEngagements((prev) => ({
                ...prev,
                [productId]: {
                    EngagementLike: totalLikes,
                    EngagementShare: totalShares,
                    EngagementComments: uniqueComments,
                },
            }));
        } catch (error) {
            console.error(`❌ Error fetching engagement for product ${productId}:`, error);
        }
    };


    useEffect(() => {
        if (data?.length > 0) {
            data.forEach((product: any) => {
                fetchEngagementData(product.id);
            });
        }
    }, [data]);

    // ---------------------- Like Button ----------------------
    const handleLike = async (product: Product) => {
        try {
            const prev = engagements[product.id] || {
                EngagementLike: 0,
                EngagementComments: [],
                EngagementShare: 0,
            };


            // Update UI instantly
            setEngagements((prevData) => ({
                ...prevData,
                [product.id]: {
                    ...prev,
                    EngagementLike: prev.EngagementLike + 1
                }
            }));

            // Send only increment of 1
            const postResponse = await POST(API.CREATE_ENGAGEMENT_BUTTON, {
                productId: product.id,
                EngagementLike: 1,
                EngagementComments: JSON.stringify([]),
                EngagementShare: 0,
            });


            notification.success({ message: "Liked!" });

            // Refresh to get accurate count
            setTimeout(() => {
                fetchEngagementData(product.id);
            }, 500);
        } catch (error) {
            notification.error({ message: "Failed to like" });

            // Revert on error
            const prev = engagements[product.id];
            if (prev) {
                setEngagements((prevData) => ({
                    ...prevData,
                    [product.id]: {
                        ...prev,
                        EngagementLike: Math.max(0, prev.EngagementLike - 1)
                    }
                }));
            }
        }
    };

    // ---------------------- Comment Submit ----------------------
    const handleCommentSubmit = async (product: Product) => {
        if (!newComment.trim()) {
            notification.warning({ message: "Please enter a comment" });
            return;
        }

        const commentToAdd = newComment.trim();
        const prev = engagements[product.id] || {
            EngagementLike: 0,
            EngagementComments: [],
            EngagementShare: 0,
        };


        // Update UI instantly
        setEngagements((prevData) => ({
            ...prevData,
            [product.id]: {
                ...prev,
                EngagementComments: [...prev.EngagementComments, commentToAdd]
            }
        }));
        setNewComment("");
        setIsModalOpen(false);

        try {
            setLoading(true);

            // Send only the new comment
            const postResponse = await POST(API.CREATE_ENGAGEMENT_BUTTON, {
                productId: product.id,
                EngagementLike: 0,
                EngagementComments: JSON.stringify([commentToAdd]),
                EngagementShare: 0,
            });


            notification.success({ message: "Comment added!" });

            // Refresh
            setTimeout(() => {
                fetchEngagementData(product.id);
            }, 500);
        } catch (error) {
            notification.error({ message: "Failed to add comment" });

            // Revert UI
            setEngagements((prevData) => ({
                ...prevData,
                [product.id]: {
                    ...prev,
                    EngagementComments: prev.EngagementComments.filter(c => c !== commentToAdd)
                }
            }));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const checkScrollTop = () => {
            if (window.scrollY > 300) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };
        window.addEventListener('scroll', checkScrollTop);
        return () => window.removeEventListener('scroll', checkScrollTop);
    }, []);

    // Scroll to the top when clicking the button
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const fetchOneProduct = async () => {
        try {
            setIsLoading(true);
            const api = API.GET_ONE_PRODUCT + id;
            const response: any = await GET(api, {});

            if (response?.data) {
                setData(response.data);
                setProductImages([
                    response.data.productImage1,
                    response.data.productImage2,
                    response.data.productImage3,
                    response.data.productImage4
                ].filter(Boolean)); // Remove falsy values like null, undefined
            }
        } catch (error) {
            console.error("Error fetching product:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const shareOnWhatsApp = async (product: Product) => {
        const productOffers = Array.isArray(offerdata)
            ? offerdata.filter((offer) => offer.Product_id === product.id)
            : [];
        const offer = productOffers.length > 0 ? productOffers[0] : null;
        const finalPrice = offer ? offer.Offer_price : product.Price;
        const BASE_URL = 'https://mj4p.com';
        const productUrl = `${BASE_URL}/product/${product.id}`;
        const hasValue = (value: any) => {
            return value !== null &&
                value !== undefined &&
                value !== '' &&
                value !== '.' &&
                value.toString().trim() !== '' &&
                value.toString().trim() !== '.';
        };
        let messageParts = [];
        messageParts.push(
            `🛒 കേരളപ്ലസ് ഓൺലൈൻ ഷോപ്പിംഗ്\n📦 ഇന്ത്യ മുഴുവൻ ഡെലിവറി ലഭ്യമാണ്\n🤝 വിശ്വാസത്തോടെയും ഉറപ്പോടെയും...`
        );
        messageParts.push(`Buy here: ${productUrl}`);
        if (hasValue(product.productImage1)) {
            messageParts.push(`View product images at the link below`);
        }
        if (hasValue(product.productTitle)) {
            const stockStatus = product.stock_product === 'Out of Stock' ? ' (Out of Stock)' : '';
            messageParts.push(`*${product.productTitle}*${stockStatus}`);
        }
        if (hasValue(finalPrice)) {
            const priceText = offer ? `Rs.${finalPrice} (Offer Price)` : `Rs.${finalPrice}`;
            messageParts.push(`Price: ${priceText}`);
        }
        if (hasValue(product.descriptionProduct)) {
            messageParts.push(`Description: ${product.descriptionProduct}`);
        }
        if (hasValue(product.brand)) {
            messageParts.push(`Brand: ${product.brand}`);
        }
        if (hasValue(product.color)) {
            messageParts.push(`Color: ${product.color}`);
        }
        if (hasValue(product.gender)) {
            messageParts.push(`Gender: ${product.gender}`);
        }
        if (hasValue(product.size)) {
            messageParts.push(`Size: ${product.size}`);
        }
        if (hasValue(product.shipping)) {
            messageParts.push(`Shipping: ${product.shipping}`);
        }

        const message = `Check out this product:\n\n${messageParts.join('\n\n')}`;
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');

        // Track share
        try {
            const prev = engagements[product.id] || {
                EngagementLike: 0,
                EngagementComments: [],
                EngagementShare: 0,
            };


            // Update UI instantly
            setEngagements((prevData) => ({
                ...prevData,
                [product.id]: {
                    ...prev,
                    EngagementShare: prev.EngagementShare + 1
                }
            }));

            // Send increment
            await POST(API.CREATE_ENGAGEMENT_BUTTON, {
                productId: product.id,
                EngagementLike: 0,
                EngagementComments: JSON.stringify([]),
                EngagementShare: 1,
            });

            // Refresh
            setTimeout(() => {
                fetchEngagementData(product.id);
            }, 500);
        } catch (error) {
            console.error("❌ Error tracking share:", error);
        }
    };


    const [isInCart, setIsInCart] = useState(false);

    const handleAddToCart = async (product: any) => {
        try {
            let cartId = Number(localStorage.getItem('cartId'));
            if (!cartId) {
                const createCartResponse: any = await POST(API.CREATE_CART, {});
                cartId = createCartResponse?.id;
                localStorage.setItem('cartId', String(cartId));
            }

            const quantity = 1;
            const partnerId = Number(product.clientId || 1);

            // 🧩 Make sure offerdata exists
            if (!offerdata || !offerdata.length) {
                console.warn("⚠️ offerdata is empty");
            }

            // 🧠 Find matching offer
            const now = dayjs();
            const productOffer = offerdata?.find((offer: any) => {
                const offerProductId = Number(
                    offer.Product_id || offer.productId || offer.ProductId || offer.product?.id
                );

                // Check if this offer matches the current product
                if (offerProductId !== product.id) return false;

                // Check if offer time is valid
                const start = offer.Offer_start_time ? dayjs(offer.Offer_start_time) : null;
                const end = offer.Offer_End_time ? dayjs(offer.Offer_End_time) : null;
                const isActive =
                    (!start || now.isAfter(start)) &&
                    (!end || now.isBefore(end));

                return isActive;
            });

            // 💰 Decide final price
            const finalPrice = productOffer
                ? Number(productOffer.Offer_price)
                : Number(product.Price);



            const payload = {
                cartId: Number(cartId),
                productId: Number(product.id),
                partnerId: Number(partnerId),
                quantity,
                price: finalPrice,
                subtotal: quantity * finalPrice,
                totalPrice: quantity * finalPrice,
            };

            const addItemResponse: any = await POST(API.ADD_TO_CART, payload);

            if (addItemResponse?.status) {
                notification.success({ message: "✅ Product added to cart!" });
                setIsInCart(true);
            } else {
                notification.warning({
                    message:
                        addItemResponse?.message || "⚠️ Product already in cart",
                });
                setIsInCart(true);
            }
        } catch (err) {
            notification.error({ message: "❌ Failed to add product to cart" });
        }
    };


    const Reviewrite = async (values: any) => {
        try {
            let obj = {
                reviwerName: String(values.reviwerName),
                summary: String(values.summary),
                star: String(values.star),
                message: String(values.message),
                status: String(values.status),
                productid: Number(id),
            };
            setIsLoading(true);
            let api = API.CREATE_REVIEWS;
            const postRequest: any = await POST(api, obj);

            if (postRequest.status) {
                notification.success({ message: "Product updated successfully!" });
                form.resetFields();
                filterReviews()

            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {

            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const filterReviews = async () => {
        try {
            setIsLoading(true);
            let obj = {
                productid: Number(id)
            }
            const api = API.FILTER_REVIEWS;
            const response: any = await POST(api, obj);

            if (response?.data) {
                setReviewData(response?.data);
            } else {
                console.error("Data not available:", response);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    const filterProductData = async () => {
        try {
            setIsLoading(true);
            // Create an object but only keep values that are not empty
            let obj = { category_id: data?.category_id };


            const api = API.PRODUCT_FILTER;
            const response: any = await POST(api, obj);

            if (response?.data) {
                setProductfilterData(response?.data);
            } else {
                console.error("Data not available:", response);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (data?.category_id) {
            filterProductData();
        }
    }, [data?.category_id]);// Refetch when `id` changes
    useEffect(() => {
        fetchOneProduct();
        filterReviews()

    }, [id]); // Refetch when `id` changes

    useEffect(() => {
        fetchofferproduct()
    }, []);
    const fetchofferproduct = async () => {
        try {
            setIsLoading(true);
            const url = API.ACTIVE_OFFER_PRODUCT;
            const response: any = await GET(url, {});

            if (response?.data && Array.isArray(response.data)) {
                setofferdata(response.data.map((item: any) => ({
                    ...item,
                    Offer_start_time: item.Offer_start_time ?
                        dayjs.utc(item.Offer_start_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : '',
                    Offer_End_time: item.Offer_End_time ?
                        dayjs.utc(item.Offer_End_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : ''
                })));
            } else {
                setofferdata([]); // Ensure it's always an array
            }
        } catch (error) {
            setofferdata([]); // Prevent undefined issues
        } finally {
            setIsLoading(false);
        }
    };
    // --- CART CHECK STATE ---
    const [cartHasItems, setCartHasItems] = useState(false);
    const [cartId, setCartId] = useState<string | null>(null);
    useEffect(() => {
        const checkCart = async () => {
            const storedCartId = localStorage.getItem('cartId');
            if (!storedCartId) return;

            try {
                const response: any = await GET(`${API.LISTING_CART_DATA}${storedCartId}`, {});
                if (response?.data && response.data.length > 0) {
                    setCartHasItems(true);
                    setCartId(storedCartId);
                } else {
                    setCartHasItems(false);
                }
            } catch (error) {
                setCartHasItems(false);
            }
        };

        checkCart();
    }, [isInCart]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="product-main-page">
            {cartHasItems && (
                <div
                    style={{
                        position: 'fixed',
                        bottom: '55px',
                        right: '10px',
                        zIndex: 9999,
                    }}
                >
                    <Button
                        type="primary"
                        size="large"
                        style={{
                            backgroundColor: '#073663ff',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '12px 24px',
                            boxShadow: '0px 4px 8px rgba(0,0,0,0.2)',
                        }}
                        onClick={() => navigate(`/cart/${cartId}`)}
                    >
                        Go to Cart
                    </Button>
                </div>
            )}

            {/* Scroll to Top Button */}
            {showScroll && (
                <button className="scroll-top-button" onClick={scrollToTop}>
                    <FontAwesomeIcon icon={faArrowUp} />
                </button>
            )}
            <Header />
            <h1 style={{ textAlign: "center", paddingBottom: "30px" }}>Product Details</h1>
            <div>
                {isLoading ? (
                    <p className="loading-text">Loading...</p>
                ) : data ? (
                    <div className="main-product-view">
                        <div className="product-image-gallery">
                            {productImages.map((image, index) => (
                                <div key={index} className="thumbnail-item">
                                    <img
                                        src={image}
                                        alt={`${data?.productTitle || 'Product'} thumbnail ${index + 1}`}
                                    />
                                </div>
                            ))}
                        </div>
                        <div>
                            <Carousel
                                autoplay={true}
                                autoplaySpeed={1000}
                                arrows={true}
                                className="carousel-image-view"
                            >
                                {productImages && productImages.map((image, index) => (
                                    <div key={index} className="carousel-slide">
                                        <img src={image} alt={data?.productTitle || "Product image"}
                                            className="carousel-image"
                                            style={{ opacity: data?.stock_product === 'Out of Stock' ? '0.5' : '1' }} />
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                        <div>
                            <Card className="product-container-view">
                                <h2 className="product-title">{data?.productTitle?.toUpperCase()}</h2>
                                <p className="review-text flex items-center gap-2">
                                    <FontAwesomeIcon icon={faComments} className="text-blue-500" /> {engagements[data.id]?.EngagementComments?.length || 0} Reviews
                                </p>
                                <div className="offer-section">
                                    {offerdata.some((offer: any) => offer.Product_id === data.id) ? (
                                        (() => {
                                            const offer = offerdata.find((offer: any) => offer.Product_id === data.id);
                                            const discountedPrice = offer?.Offer_price;
                                            const discountPercentage = offer?.Offer_price
                                                ? Math.round(((data.Price - offer.Offer_price) / data.Price) * 100)
                                                : null;

                                            return (
                                                <>
                                                    <p className="offer-text">
                                                        <span className="offer-percentage">{discountPercentage}% OFF</span>
                                                        <span className="original-price">Rs. {data.Price}</span>
                                                        <span className="discounted-price">Rs. {discountedPrice}</span>
                                                    </p>
                                                    <p className="offer-time">
                                                        Offer valid from:
                                                        <span className="offer-time-value">{offer.Offer_start_time}</span>
                                                        to
                                                        <span className="offer-time-value">{offer.Offer_End_time}</span>
                                                    </p>
                                                </>
                                            );
                                        })()
                                    ) : (
                                        <p className="price">Rs. <b>{data.Price}</b></p>
                                    )}
                                </div>
                                <div className="product-info">
                                    <p><span>Brand:</span> {data?.brand}</p>
                                    <p><span>Colour:</span> {data?.color}</p>
                                    <p><span>Gender:</span> {data?.gender}</p>
                                    <p><span>Size:</span> {data?.size}</p>
                                    <p><span>shipping:</span> {data?.shipping}</p>
                                </div>
                                <div className="function-button-product">
                                    <Button
                                        onClick={() => handleAddToCart(data)}
                                        disabled={data?.stock_product === 'Out of Stock'}
                                    >
                                        {data?.stock_product === 'Out of Stock' ? 'OUT OF STOCK' : 'ADD TO CART'}
                                    </Button>

                                    <div className="button-rows">
                                        {/* Share */}
                                        <div className="icon-buttons icon-button share" onClick={() => shareOnWhatsApp(data)}>
                                            <Share2 size={18} />
                                            <span className="like-count">
                                                {engagements[data.id]?.EngagementShare || 0}
                                            </span>
                                        </div>

                                        {/* Comment */}
                                        <div
                                            className="icon-buttons icon-button comment"
                                            onClick={() => {
                                                setActiveProduct(data);
                                                setIsModalOpen(true);
                                            }}
                                        >
                                            <MessageCircle size={18} />
                                            <span className="like-count">
                                                {engagements[data.id]?.EngagementComments?.length || 0}
                                            </span>
                                        </div>

                                        {/* Like */}
                                        <div className="like-section">
                                            <div
                                                className={`icon-buttons icon-button like ${engagements[data.id]?.EngagementLike > 0 ? "active" : ""
                                                    }`}
                                                onClick={() => handleLike(data)}
                                            >
                                                <Heart
                                                    size={18}
                                                    fill={engagements[data?.id]?.EngagementLike > 0 ? "red" : "none"}
                                                />
                                            </div>
                                            <span className="like-count">
                                                {engagements[data.id]?.EngagementLike || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* 💬 Comment Modal */}
                                <Modal
                                    title="Comments"
                                    open={isModalOpen}
                                    onCancel={() => setIsModalOpen(false)}
                                    footer={null}
                                >
                                    <div style={{ maxHeight: "150px", overflowY: "auto", marginBottom: "10px" }}>
                                        {activeProduct && engagements[activeProduct.id]?.EngagementComments?.length ? (
                                            engagements[activeProduct.id].EngagementComments.map((cmt: any, index: any) => (
                                                <p key={index} style={{ borderBottom: "1px solid #eee", padding: "5px 0" }}>
                                                    {cmt}
                                                </p>
                                            ))
                                        ) : (
                                            <p style={{ color: "#aaa" }}>No comments yet</p>
                                        )}
                                    </div>

                                    <Input.TextArea
                                        rows={2}
                                        value={newComment}
                                        onChange={(e) => setNewComment(e.target.value)}
                                        placeholder="Write a comment..."
                                    />

                                    <Button
                                        type="primary"
                                        block
                                        style={{ marginTop: "10px" }}
                                        onClick={() => activeProduct && handleCommentSubmit(activeProduct)}
                                        loading={loading}
                                    >
                                        Add Comment
                                    </Button>
                                </Modal>

                            </Card>
                            <div>
                                <Card title="Write Your Review" bordered={false} >
                                    <Form form={form} onFinish={Reviewrite}>
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item
                                                    name="reviwerName"
                                                    label="Reviewer Name"
                                                    rules={[{ required: true, message: "Please enter your name" }]}
                                                >
                                                    <Input placeholder="Enter your name" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    name="star"
                                                    label="Rating"
                                                    rules={[{ required: true, message: "Please provide a rating" }]}
                                                >
                                                    <Rate />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <Form.Item
                                                    name="message"
                                                    label="Message"
                                                    rules={[{ required: true, message: "Please enter your review" }]}
                                                >
                                                    <Input.TextArea rows={3} placeholder="Write your review here" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    name="summary"
                                                    label="Summary"
                                                    rules={[{ required: true, message: "Please enter a summary" }]}
                                                >
                                                    <Input.TextArea rows={2} placeholder="Write a short summary" />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        <Button type="primary" htmlType="submit" block>
                                            Submit Review
                                        </Button>
                                    </Form>
                                </Card>
                            </div>
                        </div>
                    </div>
                ) : (
                    <p className="error-text">Product not found.</p>
                )}
                <div style={{ maxWidth: 1200, margin: "auto" }} className="Review-container">
                    <h4>Others Telling About This Product</h4>

                    {reviewData.length === 0 ? (
                        <p style={{ textAlign: "center", padding: "20px", fontSize: "16px", color: "gray" }}>
                            No reviews found.
                        </p>
                    ) : (
                        reviewData.slice(0, visibleCount).map((review: any) => (
                            <Card key={review.id} style={{ marginBottom: 16, padding: "10px" }}>
                                <Row gutter={16} align="middle">
                                    <Col span={20}>
                                        <Avatar>
                                            {review.reviwerName ? review.reviwerName.charAt(0).toUpperCase() : "U"}
                                        </Avatar>
                                        <br />
                                        <strong>{review.reviwerName}</strong>
                                        <div>
                                            <Rate disabled defaultValue={parseInt(review.star) || 0} />
                                        </div>
                                    </Col>
                                    <Col span={20}>
                                        <div>
                                            <h5>"{review.summary}"</h5>
                                            <p>{review.message}</p>
                                        </div>
                                    </Col>
                                    <Col span={2} style={{ textAlign: "right" }}>
                                        <span>{review.createdAt ? new Date(review.createdAt).toLocaleDateString() : "N/A"}</span>
                                    </Col>
                                </Row>
                            </Card>
                        ))
                    )}

                    {reviewData.length > 3 && (
                        <Button type="link" onClick={visibleCount === 3 ? showMoreReviews : showLessReviews}>
                            {visibleCount === 3 ? "Read More" : "Show Less"}
                        </Button>
                    )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                    <Button
                        onClick={() => {
                            navigate('/');
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth' // optional smooth animation
                            });
                        }}
                        style={{
                            fontSize: '2rem',
                            padding: '25px',
                            color: '#fff',
                            backgroundColor: '#007fd3ff',
                        }}
                    >
                        HOME
                    </Button>
                </div>

                <div >
                    <h3>Related Products</h3>
                    <hr />
                    <div className="product-lists">
                        {ProductfilterData?.map((product: any, index: number) => {
                            const productImages = [
                                product.productImage1,
                                product.productImage2,
                                product.productImage3,
                                product.productImage4
                            ].filter(Boolean); // Remove undefined/null values

                            // Find if this product has an active offer
                            const offer = offerdata.find((offer: any) => offer.Product_id === product.id);
                            const hasOffer = !!offer;
                            const discountedPrice = hasOffer ? offer.Offer_price : product.Price;
                            const discountPercentage = hasOffer
                                ? Math.round(((product.Price - offer.Offer_price) / product.Price) * 100)
                                : null;
                            const isOutOfStock = product?.stock_product === 'Out of Stock';

                            return (
                                <div key={index} className="product-card">
                                    <div className="carousel-container">
                                        <Carousel
                                            autoplay={true}
                                            autoplaySpeed={3000}
                                            arrows={true}
                                            dots={true}
                                            slidesToShow={1}
                                            slidesToScroll={1}
                                            className="product-carousel"
                                        >
                                            {productImages.map((image, imgIndex) => (
                                                <div key={imgIndex} className="carousel-slide">
                                                    <img
                                                        src={image}
                                                        alt={product.productTitle}
                                                        className="carousel-images"
                                                        onClick={() => navigate(`/product/${product.id}`)}
                                                        style={{ opacity: isOutOfStock ? '0.5' : '1' }}
                                                    />
                                                </div>
                                            ))}
                                        </Carousel>
                                    </div>

                                    <div className="function-button-product">
                                        <div className="function-button-product">
                                            <Button
                                                onClick={() => handleAddToCart(product)}
                                                disabled={isOutOfStock}
                                            >
                                                {isOutOfStock ? 'OUT OF STOCK' : 'ADD TO CART'}
                                            </Button>

                                            <div className="button-rows">
                                                {/* Share */}
                                                <div className="icon-buttons icon-button share" onClick={() => shareOnWhatsApp(product)}>
                                                    <Share2 size={18} />
                                                    <span className="like-count">
                                                        {engagements[product.id]?.EngagementShare || 0}
                                                    </span>
                                                </div>

                                                {/* Comment */}
                                                <div
                                                    className="icon-buttons icon-button comment"
                                                    onClick={() => {
                                                        setActiveProduct(product);
                                                        setIsModalOpen(true);
                                                    }}
                                                >
                                                    <MessageCircle size={18} />
                                                    <span className="like-count">
                                                        {engagements[product.id]?.EngagementComments?.length || 0}
                                                    </span>
                                                </div>

                                                {/* Like */}
                                                <div className="like-section">
                                                    <div
                                                        className={`icon-buttons icon-button like ${engagements[product.id]?.EngagementLike > 0 ? "active" : ""
                                                            }`}
                                                        onClick={() => handleLike(product)}
                                                    >
                                                        <Heart
                                                            size={18}
                                                            fill={engagements[product?.id]?.EngagementLike > 0 ? "red" : "none"}
                                                        />
                                                    </div>
                                                    <span className="like-count">
                                                        {engagements[product.id]?.EngagementLike || 0}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 💬 Comment Modal */}
                                        <Modal
                                            title="Comments"
                                            open={isModalOpen}
                                            onCancel={() => setIsModalOpen(false)}
                                            footer={null}
                                        >
                                            <div style={{ maxHeight: "150px", overflowY: "auto", marginBottom: "10px" }}>
                                                {activeProduct && engagements[activeProduct.id]?.EngagementComments?.length ? (
                                                    engagements[activeProduct.id].EngagementComments.map((cmt: any, index: any) => (
                                                        <p key={index} style={{ borderBottom: "1px solid #eee", padding: "5px 0" }}>
                                                            {cmt}
                                                        </p>
                                                    ))
                                                ) : (
                                                    <p style={{ color: "#aaa" }}>No comments yet</p>
                                                )}
                                            </div>

                                            <Input.TextArea
                                                rows={2}
                                                value={newComment}
                                                onChange={(e) => setNewComment(e.target.value)}
                                                placeholder="Write a comment..."
                                            />

                                            <Button
                                                type="primary"
                                                block
                                                style={{ marginTop: "10px" }}
                                                onClick={() => activeProduct && handleCommentSubmit(activeProduct)}
                                                loading={loading}
                                            >
                                                Add Comment
                                            </Button>
                                        </Modal>
                                    </div>
                                    <br />
                                    <h2 className="product-name">{product.productTitle}</h2>

                                    {hasOffer ? (
                                        <p className="offer-text">
                                            <span className="offer-percentage">{discountPercentage}% OFF</span>
                                            <span className="original-price">Rs. {product.Price}</span>
                                            <span className="discounted-price">Rs. {discountedPrice}</span>
                                            <br />
                                            <span className="offer-time">
                                                Offer valid from: {offer.Offer_start_time} to {offer.Offer_End_time}
                                            </span>
                                        </p>
                                    ) : (
                                        <li style={{ listStyle: "none" }}>
                                            Rs: <b>{product.Price}</b>
                                            <li>{product.descriptionProduct}</li>
                                        </li>
                                    )}
                                    <Button
                                        onClick={() => {
                                            if (product && product.id) {
                                                navigate(`/product/${product.id}`);
                                            } else {
                                                console.error("Product ID is missing", product);
                                            }
                                        }}
                                    >
                                        View Details
                                    </Button>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                        <Button
                            onClick={() => {
                                navigate('/');
                            }}
                            style={{
                                fontSize: '2rem',
                                padding: '25px',
                                color: '#fff',
                                backgroundColor: '#007fd3ff',
                            }}
                        >
                            NEXT
                        </Button>
                    </div>
                </div>
            </div>
            <FooterWeb />
        </div>
    );
}

export default ViewProductDetails;